/* 
 *  Created by RRamireddygari 02/14/2018
 */

import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RepoFolder } from '~config/model/repofolder';
import { Jsonp } from '@angular/http';
import { BI_HttpService } from '../../services/http.service';
import { ConfigConstants } from '~config/util/config.constant';

@Injectable()
export class RepofolderService {

  public repFolders: RepoFolder[];
  public companyfolders: RepoFolder[];
  public searchTerm: FormControl = new FormControl();

  constructor(private http: BI_HttpService, private jsonp: Jsonp) {
  }

  getRepoFolders() {
    return this.http.get(ConfigConstants.BI_FOLDERS_URL);
  }

  getReportsInTheFolder(folderId) {
    if (folderId.folderId)
      folderId = folderId.folderId;
    return this.http.get(ConfigConstants.GET_FOLDER_REPORTS_DATA_URL + folderId);
  }

  saveRowData(data) {
    return this.http.post(ConfigConstants.SAVE_REPORT_DATA_URL, data);
  }

  updatebi(data) {
    return this.http.get(ConfigConstants.BI_UPDATE_BI_URL + data);
  }

  syncWithCognos() {
    return this.http.get(ConfigConstants.BI_SYNC_WITH_COGNOS_URL);

  }

  search_word(term) {
    return this.http.get(ConfigConstants.GET_COMPANY_FOLDERS_URL + term).map(res => {
      return res;
    })
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/services/repofolder.service.ts